var React = require('react');

function CircleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M441.8,376.3v20.8c0,62.7-24.5,121.7-68.9,166c-44.3,44.3-103.3,68.7-165.9,68.7h-0.1\n\tc-62.7,0-121.7-24.5-166-68.9c-44.3-44.4-68.7-103.3-68.7-166.1c0-62.7,24.5-121.7,68.9-166c44.3-44.3,103.3-68.7,165.9-68.7h0.1\n\tc33.1,0,65.2,6.8,95.4,20.3c5.4,2.4,7.8,8.7,5.4,14.1c-1.7,3.8-5.6,6.3-9.8,6.3c-1.5,0-3-0.3-4.3-0.9\n\tc-27.5-12.2-56.7-18.5-86.7-18.5H207c-57,0-110.5,22.2-150.8,62.4C15.8,286.3-6.4,339.9-6.4,396.9\n\tc-0.1,117.7,95.6,213.5,213.3,213.5h0.1c57,0,110.5-22.2,150.8-62.4c40.3-40.3,62.6-93.9,62.6-150.9v-20.8c0-5.9,4.8-10.7,10.7-10.7\n\tC437,365.6,441.8,370.4,441.8,376.3z"}));
}

CircleIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-49 141 512 512","style":{"enableBackground":"new -49 141 512 512"},"xmlSpace":"preserve"};

module.exports = CircleIcon;

CircleIcon.default = CircleIcon;
